import { useEffect, useState } from "react";

/**
 * El modo operativo (SCRUM-81, POS/Salón/KDS) puede usar Fullscreen API real
 * (`Element.requestFullscreen()`). Mientras un elemento está en fullscreen,
 * el navegador solo compositea ese elemento y sus descendientes — cualquier
 * contenido portado a `document.body` (todos los overlays de Radix por
 * default: Dialog, Sheet, Popover, DropdownMenu, Select, AlertDialog,
 * Tooltip) queda fuera del árbol renderizado y no se ve, o queda detrás.
 *
 * Este hook expone el elemento en fullscreen (o null) para usarlo como
 * `container` del Portal correspondiente, así el overlay se monta dentro
 * del propio elemento fullscreen en vez de document.body.
 */
export function useFullscreenElement(): HTMLElement | null {
  const [el, setEl] = useState<HTMLElement | null>(() =>
    typeof document !== "undefined" ? (document.fullscreenElement as HTMLElement | null) : null,
  );

  useEffect(() => {
    const handler = () => setEl(document.fullscreenElement as HTMLElement | null);
    document.addEventListener("fullscreenchange", handler);
    return () => document.removeEventListener("fullscreenchange", handler);
  }, []);

  return el;
}
